import type { EstadoLoto } from "@/lib/lotos";

// Etiqueta + color de cada estado del ciclo de vida binario del LOTO (badge, #241). Mismos
// colores que el panel (#43) para que el estado se lea igual en el índice, la ficha y el
// dashboard.
export const ESTADO_LOTO: Record<EstadoLoto, { label: string; className: string }> = {
  ABIERTO: { label: "Abierto", className: "bg-navy-100 text-navy-800" },
  CERRADO: { label: "Cerrado", className: "bg-slate-100 text-slate-600" },
};

/**
 * EstadoLotoBadge pinta el estado de un LOTO como badge de color. Acepta un string por
 * robustez (el backend devuelve `estado:string`); un valor desconocido cae a un badge
 * neutro con su propia etiqueta.
 */
export function EstadoLotoBadge({ estado }: { estado: string }) {
  const info = ESTADO_LOTO[estado as EstadoLoto] ?? {
    label: estado,
    className: "bg-slate-100 text-slate-600",
  };
  return (
    <span
      className={`inline-flex items-center rounded-full px-2.5 py-0.5 font-semibold text-xs ${info.className}`}
    >
      {info.label}
    </span>
  );
}
